export const environment = {
    name: 'global',

    production: false,
    application: 'ISA',
    domain: 'localhost',
    scheme: 'http',
    port: 8000,
    app_port: 4000,

    pagination: {
        default: 25,
        payments: 5,
        courses: 2,
        jobs: 12,
        home: 5,
    },

    debounce: {
        // default Search field debounce timeout in ms
        default: 750,
    },

    routes: {
        home: '/',
        guest: '/auth/login',
    },

    services: {
        recaptcha: {
            key: '6LeXo2cUAAAAANViYrvfPLxzK5VfAOmtTNU-5FlM',
        },
        paypal: {
            key: 'AW_fxPJSdjEMAL3SAwWy6Q7wjnU5uzNoqARO-9xpkmvz25PrppVoBHDQrSsABkhMS6X25IPP-Z_OafcQ',
        },
        firebase: {
            apiKey: "AIzaSyBRmAeUlfMep3ZiMnUYT9uYNMntcV2NATA",
            authDomain: "ice-star-academy.firebaseapp.com",
            databaseURL: "https://ice-star-academy-default-rtdb.europe-west1.firebasedatabase.app",
            projectId: "ice-star-academy",
            storageBucket: "ice-star-academy.appspot.com",
            messagingSenderId: "851853299709",
            appId: "1:851853299709:web:79a44fffa33b5431665394"
        },
        iframe: {
            key: '7e46fa02ac0d2e5278e557'
        }
    },

    caching: {
        default: 5 * 60 * 1000, // 5 min
        sidebar: 15 * 60 * 1000, // 15 min. for most of sidebar items
    },

    features: {
        // Later will turn it on - it's annoying during development
        recaptcha: false,
    },

    locales: {
        // all available locales
        // @note: Do not translate labels!
        // @note2: DON'T use language-only codes!
        available: [{
            'id': 'bg_BG',
            'label': "Български език",
        }, {
            'id': 'en_US',
            'label': "English Language",
        }, {
            'id': 'ru_RU',
            'label': "Русский язык",
        }, {
            'id': 'uk_UA',
            'label': "Українська мова",
        }],

        // Default locale as fallback
        default: 'bg_BG'
    },
};
